import { Carousel, Col, Row } from '@farol-ds/react'
import classNames from 'classnames'
import { ReactNode } from 'react'

import styles from './paywall-carousel.module.scss'

export interface PaywallCarouselProps<T> {
  cards: T[]
  renderCard: (card: T, index: number) => ReactNode
  mobileClassName?: string
  desktopClassName?: string
  carouselItemClassName?: string
}

export const PaywallCarousel = <T,>(props: PaywallCarouselProps<T>) => {
  const { cards, renderCard, mobileClassName, desktopClassName, carouselItemClassName } = props

  const mobileClasses = classNames(styles.rowMobile, mobileClassName)
  const desktopClasses = classNames(styles.rowDesktop, desktopClassName)
  const carouselItemClasses = classNames(styles.carouselItem, carouselItemClassName)

  return (
    <>
      <Row className={mobileClasses}>
        {cards.map((card, index) => {
          return (
            <Col key={index} xs={12}>
              {renderCard(card, index)}
            </Col>
          )
        })}
      </Row>

      <Row className={desktopClasses}>
        <Col xs={12} className={styles.colDesktop}>
          <Carousel data-testid="PaywallCarousel">
            <Carousel.List className={styles.carouselList}>
              {cards.map((card, index) => {
                return (
                  <Carousel.Item key={index} className={carouselItemClasses}>
                    {renderCard(card, index)}
                  </Carousel.Item>
                )
              })}
            </Carousel.List>
            {cards.length > 1 && <Carousel.Pagination className={styles.carouselPagination} />}
          </Carousel>
        </Col>
      </Row>
    </>
  )
}
